/**
 * @see https://gitlab.com/mindtickle/dsr/dsr-core-api/-/blob/track/integration/app/graphql/application/types/rooms/room_audience_enum_type.rb
 */
export enum RoomAudience {
  Internal = 'internal',
  External = 'external',
}

export const AUDIENCE = {
  [RoomAudience.Internal]: 'internal',
  [RoomAudience.External]: 'sales',
};

export const isInternalRoom = (room: { audience: RoomAudience }) =>
  room.audience === RoomAudience.Internal;
